/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import React from "react";
import Head from "next/head";
import Header from "../../../common/header/Header";
import Footer from "../../../common/footer/Footer";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      em: "em",
      h2: "h2",
      h3: "h3",
      ul: "ul",
      li: "li",
      a: "a"
    }, props.components);
    return _jsxs("main", {
      className: "page-wrapper",
      children: [_jsx(Head, {
        children: _jsx("title", {
          children: "Modulabs | Taxes Policy"
        })
      }), _jsx(Header, {
        className: "header-not-transparent"
      }), _jsx("div", {
        className: "post-page-banner rn-section-gapTop",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content text-center",
                children: _jsx("div", {
                  className: "page-title",
                  children: _jsx("h1", {
                    className: "theme-gradient",
                    children: "Taxes Policy"
                  })
                })
              })
            })
          })
        })
      }), _jsx("div", {
        className: "blog-details-content pt--60 rn-section-gapBottom",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content",
                children: _jsxs("div", {
                  children: [_jsxs(_components.p, {
                    children: ["Taxes are an important part of functional society. Where our products are taxable, we\ncollect and remit consumption tax to governments at the local, state, and/or federal levels.\nIf your billing address is in one of the following jurisdictions, you’ll see an ", _jsx(_components.em, {
                      children: "additional"
                    }), "\nline item on your invoice for sales tax or VAT. The subscription prices on our product\nwebsites are all exclusive of sales tax and VAT."]
                  }), _jsx(_components.p, {
                    children: "The tax rate and rules are determined by each jurisdiction and sometimes vary by whether you\nare using our products for business/commercial or personal purposes. As regulations change,\nwe will update this list."
                  }), _jsx(_components.h2, {
                    children: "Jurisdictions we collect and remit taxes for"
                  }), _jsx(_components.h3, {
                    children: "Within the US"
                  }), _jsx(_components.p, {
                    children: "We collect sales tax from customers based in:"
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsxs(_components.li, {
                      children: ["Alaska (only ", _jsx(_components.a, {
                        href: "https://arsstc.munirevs.com/show-page/?page=26",
                        children: "certain jurisdictions"
                      }), "\ncharge sales tax)"]
                    }), "\n", _jsx(_components.li, {
                      children: "Arizona"
                    }), "\n", _jsx(_components.li, {
                      children: "Chicago (Illinois)"
                    }), "\n", _jsx(_components.li, {
                      children: "Connecticut"
                    }), "\n", _jsx(_components.li, {
                      children: "District of Columbia"
                    }), "\n", _jsx(_components.li, {
                      children: "Hawaii"
                    }), "\n", _jsx(_components.li, {
                      children: "Iowa"
                    }), "\n", _jsx(_components.li, {
                      children: "Massachusetts"
                    }), "\n", _jsx(_components.li, {
                      children: "New Mexico"
                    }), "\n", _jsx(_components.li, {
                      children: "Ohio"
                    }), "\n", _jsx(_components.li, {
                      children: "Pennsylvania"
                    }), "\n", _jsx(_components.li, {
                      children: "Rhode Island"
                    }), "\n", _jsx(_components.li, {
                      children: "South Carolina"
                    }), "\n", _jsx(_components.li, {
                      children: "South Dakota"
                    }), "\n", _jsx(_components.li, {
                      children: "Tennessee"
                    }), "\n", _jsx(_components.li, {
                      children: "Texas"
                    }), "\n", _jsx(_components.li, {
                      children: "Utah"
                    }), "\n", _jsx(_components.li, {
                      children: "Washington"
                    }), "\n", _jsx(_components.li, {
                      children: "West Virginia"
                    }), "\n"]
                  }), _jsxs(_components.p, {
                    children: ["Each US state has their own sales tax exemption rules. If your organization is tax-exempt,\nplease share your ", _jsx(_components.em, {
                      children: "state-specific"
                    }), " tax exemption documentation with us. Because not all US\nfederal exemptions are recognized by each state, an IRS tax exemption letter is not enough."]
                  }), _jsx(_components.h3, {
                    children: "Within the EU"
                  }), _jsx(_components.p, {
                    children: "We collect VAT on any direct-to-consumer sales to EU-based customers."
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsx(_components.li, {
                      children: "Austria"
                    }), "\n", _jsx(_components.li, {
                      children: "Belgium"
                    }), "\n", _jsx(_components.li, {
                      children: "Bulgaria"
                    }), "\n", _jsx(_components.li, {
                      children: "Croatia"
                    }), "\n", _jsx(_components.li, {
                      children: "Cyprus"
                    }), "\n", _jsx(_components.li, {
                      children: "Czechia"
                    }), "\n", _jsx(_components.li, {
                      children: "Denmark"
                    }), "\n", _jsx(_components.li, {
                      children: "Estonia"
                    }), "\n", _jsx(_components.li, {
                      children: "Finland"
                    }), "\n", _jsx(_components.li, {
                      children: "France"
                    }), "\n", _jsx(_components.li, {
                      children: "Germany"
                    }), "\n", _jsx(_components.li, {
                      children: "Greece"
                    }), "\n", _jsx(_components.li, {
                      children: "Hungary"
                    }), "\n", _jsx(_components.li, {
                      children: "Ireland"
                    }), "\n", _jsx(_components.li, {
                      children: "Italy"
                    }), "\n", _jsx(_components.li, {
                      children: "Latvia"
                    }), "\n", _jsx(_components.li, {
                      children: "Lithuania"
                    }), "\n", _jsx(_components.li, {
                      children: "Luxembourg"
                    }), "\n", _jsx(_components.li, {
                      children: "Malta"
                    }), "\n", _jsx(_components.li, {
                      children: "Netherlands"
                    }), "\n", _jsx(_components.li, {
                      children: "Poland"
                    }), "\n", _jsx(_components.li, {
                      children: "Portugal"
                    }), "\n", _jsx(_components.li, {
                      children: "Romania"
                    }), "\n", _jsx(_components.li, {
                      children: "Sweden"
                    }), "\n", _jsx(_components.li, {
                      children: "Slovakia"
                    }), "\n", _jsx(_components.li, {
                      children: "Slovenia"
                    }), "\n", _jsx(_components.li, {
                      children: "Spain"
                    }), "\n", _jsx(_components.li, {
                      children: "United Kingdom"
                    }), "\n"]
                  }), _jsx(_components.h3, {
                    children: "Within Canada"
                  }), _jsx(_components.p, {
                    children: "We collect GST/HST (and PST where applicable) on sales to Canadian customers based in:"
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsx(_components.li, {
                      children: "Alberta"
                    }), "\n", _jsx(_components.li, {
                      children: "British Columbia (+ PST)"
                    }), "\n", _jsx(_components.li, {
                      children: "Manitoba"
                    }), "\n", _jsx(_components.li, {
                      children: "New Brunswick"
                    }), "\n", _jsx(_components.li, {
                      children: "Newfoundland and Labrador"
                    }), "\n", _jsx(_components.li, {
                      children: "Northwest Territories"
                    }), "\n", _jsx(_components.li, {
                      children: "Nova Scotia"
                    }), "\n", _jsx(_components.li, {
                      children: "Nunavut"
                    }), "\n", _jsx(_components.li, {
                      children: "Ontario"
                    }), "\n", _jsx(_components.li, {
                      children: "Prince Edward Island"
                    }), "\n", _jsx(_components.li, {
                      children: "Quebec"
                    }), "\n", _jsx(_components.li, {
                      children: "Saskatchewan"
                    }), "\n", _jsx(_components.li, {
                      children: "Yukon"
                    }), "\n"]
                  }), _jsx(_components.h2, {
                    children: "Updating your billing address"
                  }), _jsx(_components.p, {
                    children: "If you need to change your billing information because you don’t actually reside in a\ntaxable jurisdiction, you can easily handle that within your accounts. You may need to\nre-enter your credit card information as part of the billing address update."
                  }), _jsx(_components.h2, {
                    children: "We’re here to help"
                  }), _jsxs(_components.p, {
                    children: ["Please ", _jsx(_components.a, {
                      href: "mailto:support@modulabs.io",
                      children: "contact our Support team"
                    }), " if you have trouble or if:"]
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsx(_components.li, {
                      children: "you believe you’re being charged in error."
                    }), "\n", _jsx(_components.li, {
                      children: "your organization is tax exempt or has a VAT identification number. Alongside your tax\nexempt certification or VAT identification number."
                    }), "\n", _jsx(_components.li, {
                      children: "you have any additional questions."
                    }), "\n"]
                  }), _jsxs(_components.p, {
                    children: ["Adapted from the ", _jsx(_components.a, {
                      href: "https://github.com/basecamp/policies",
                      children: "Basecamp open-source policies"
                    }), " / ", _jsx(_components.a, {
                      href: "https://creativecommons.org/licenses/by/4.0/",
                      children: "CC\nBY 4.0"
                    })]
                  })]
                })
              })
            })
          })
        })
      }), _jsx(Footer, {})]
    });
  }
}
export default MDXContent;
